export default {
  notAvailable: 'N/D'
}
